import { render, staticRenderFns } from "./CcTask.vue?vue&type=template&id=2c22a1b8&scoped=true&"
import script from "./CcTask.vue?vue&type=script&lang=js&"
export * from "./CcTask.vue?vue&type=script&lang=js&"
import style0 from "./CcTask.vue?vue&type=style&index=0&id=2c22a1b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22a1b8",
  null
  
)

export default component.exports